// src/errors/index.js

/**
 * Clase de error personalizada para errores de la API de Apacuana.
 */
export class ApacuanaAPIError extends Error {
  constructor(message, statusCode = 500, errorCode = null) {
    super(message);
    this.name = "ApacuanaAPIError";
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.success = false; // Añadir el atributo success con valor false

    // Mantener el stack trace correcto
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApacuanaAPIError);
    }
  }
}

export default ApacuanaAPIError;
